module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_groups/assets/passed-2993b34f079bfefdd06f2048eb084d90.png";